import { getMyIpMediaReferences, getMyIpMediaReferenceUrl } from './mediaReferences';
import { getMyIpMediaUrl } from './mediaUrl';
import type { MyIpItem } from './types';
import { getMyIpSelectedVoice } from './voiceSelection';
import { isMyIpGeneratedImage } from './imageSource';

/** 优先投影当前授权资源的签名地址；已有生成来源清单时，只给当前生成图使用水印。 */
export function getMyIpDetailMedia(item?: MyIpItem) {
  const references = item ? getMyIpMediaReferences(item).references : [];
  const resourceUrls: Record<string, string> = Object.fromEntries(references.flatMap((reference) => (
    reference.assetId && getMyIpMediaReferenceUrl(reference) ? [[reference.assetId, getMyIpMediaReferenceUrl(reference)!]] : []
  )));
  const threeViews = references
    .filter((reference) => reference.role === 'three_view' && reference.type === 'image')
    .flatMap((reference) => {
      const url = getMyIpMediaReferenceUrl(reference, resourceUrls);
      return url ? [{
        url,
        assetId: reference.assetId,
        // 兼容没有来源清单的旧 IP；新 IP 手工换图后服务端残留的旧水印不能遮住新原图。
        watermarkUrl: item && Array.isArray(item.profile.generated_image_keys)
          && !isMyIpGeneratedImage(item.profile, url) ? undefined : getMyIpMediaUrl(reference.watermarkUrl),
        width: reference.width,
        height: reference.height,
      }] : [];
    });
  // 同址去重时保留首次出现的水印，保证展示列表与水印下标对齐。
  const uniqueThreeViews = Array.from(new Map(threeViews.map((entry) => [entry.url, entry])).values());
  const voice = item ? getMyIpSelectedVoice(item) : null;
  const coverUrl = getMyIpMediaUrl(item?.coverUrl);
  const coverWatermarkUrl = getMyIpMediaUrl(item?.coverWatermarkUrl);
  const avatarUrl = getMyIpMediaUrl(item?.avatarUrl) || coverUrl;
  // 头像回退主视觉时，水印也跟着主视觉；独立头像缺水印时不误用封面水印。
  const avatarWatermarkUrl = getMyIpMediaUrl(item?.avatarUrl)
    ? getMyIpMediaUrl(item?.avatarWatermarkUrl)
    : coverWatermarkUrl;
  return {
    coverUrl,
    coverWatermarkUrl,
    // 服务端未下发头像时，所有展示入口统一回退当前主视觉；不把回退结果写回头像字段。
    avatarUrl,
    avatarWatermarkUrl,
    threeViewUrls: uniqueThreeViews.map((entry) => entry.url),
    threeViewWatermarkUrls: uniqueThreeViews.map((entry) => entry.watermarkUrl),
    threeViews: uniqueThreeViews,
    voiceUrl: voice?.url,
    voiceName: voice?.name,
    resourceUrls,
  };
}
